import api from './baseApi';
import type { ListMasksDto, MaskDto, RegisterMaskDto } from './typings/mask';
import { MaskType } from '@/utils/enums/maskType.enum';

const controller = '/Mask';

export const getDefaultMasks = (type = MaskType.Mask): Promise<MaskDto[]> =>
    api
        .get<MaskDto[]>(`${controller}/Defaults`, { params: { type } })
        .then(({ data }) => data);

export const getUserMasks = (page: number, pageSize: number, type = MaskType.Mask): Promise<ListMasksDto> =>
    api
        .get<ListMasksDto>(controller, { params: { page, pageSize, type } })
        .then(({ data }) => data);

export const registerMask = (mask: RegisterMaskDto): Promise<MaskDto> =>
    api.post<MaskDto>(controller, mask).then(({ data }) => data);
